import './index.scss';

import { Component } from 'react';

import t from 'utils/i18n';
import { BraxButton } from '../BraxButton';
import { BraxIcon } from '../BraxIcon';

export type BraxFileButtonProps = {
    url: string
};

export class BraxFileButton extends Component<BraxFileButtonProps> {

    readonly FORMATS: { [key: string]: string } = {
        '.pdf': 'Arquivo PDF',
        '.png': 'Imagem',
        '.jpg': 'Imagem',
        '.jpeg': 'Imagem',
        '.svg': 'Imagem vetorial',
        '.xls': 'Planilha',
        '.xlsx': 'Planilha',
        '.doc': 'Documento de Texto',
        '.docx': 'Documento de Texto',
        '.ppt': 'Apresentação',
        '.pptx': 'Apresentação'
    };
    
    name: string;

    format: string;

    constructor(props: BraxFileButtonProps) {
        super(props);

        this.name = this.props.url.substring(this.props.url.lastIndexOf('/') + 1);

        this.format = this.name.substring(this.name.lastIndexOf('.'));
    }

    render() {
        return (
            <a href={this.props.url} target="_blank" rel="noopener noreferrer" className="brax-file-button">
                <BraxButton variant="light">
                    <span>
                        <BraxIcon icon="file" />

                        <span>
                            <span>{ this.name }</span>

                            <span className="hint">
                                { this.FORMATS[this.format] ? t(this.FORMATS[this.format]) : t('Arquivo %s', this.format) }
                            </span>
                        </span>
                    </span>
                </BraxButton>
            </a>
        );
    }

}
